import React from "react";
import PropTypes from "prop-types";

import arrow from "assets/graphics/icons/arrow.png";

import "features/new/slider/view.scss";

const SliderView = ({
  slideImages,
  slideTexts,
  activeSlideIndex,
  sliderPosition,
  isTransitioned,
  isSlid,
  slide,
  isImagesLoaded,
}) =>
  isImagesLoaded ? (
    <div className="header__container">
      <section className="header__slider" onClick={slide}>
        <div
          className="slider__backgrounds"
          style={{ transform: `translateX(-${sliderPosition}%)` }}
        >
          {slideImages.map((image, index) => (
            <div
              className="slider__background"
              key={index}
              style={{ backgroundImage: `url(${image.backgroundImage})` }}
            >
              <img
                className="slider__image__background"
                src={image.backgroundImage}
                key={index}
              />
            </div>
          ))}
        </div>
        <div className="slider__container">
          <div
            className="slider__images"
            style={{
              transform: `translateX(-${sliderPosition}%)`,
              transitionDuration: isTransitioned ? "0.4s" : "0s",
            }}
          >
            {slideImages.map((image, index) => (
              <img
                className={`slider__image${
                  activeSlideIndex === index + 1 ? "--previous" : ""
                }`}
                style={{ transitionDuration: isTransitioned ? "0.4s" : "0s" }}
                src={image.image}
                alt={image.alternate}
                key={index}
              />
            ))}
          </div>
          <div
            className="slider__layouts"
            style={{ transform: `translateX(-${sliderPosition}%)` }}
          >
            {slideTexts.map((text, index) => (
              <div
                className={`slider__layout${
                  activeSlideIndex === index ? "--active" : ""
                }`}
                key={index}
              >
                <div className="slider__fake-image"></div>
                <h1 className="slider__headline">
                  {text.headline}
                  <span className={`slider__dot${!isSlid ? "--active" : ""}`}>
                    .
                  </span>
                </h1>
                <p className="slider__description--mobile">
                  {text.description}
                </p>
              </div>
            ))}
          </div>
          <div
            className="slider__layouts slider__descriptions"
            style={{ transform: `translateX(-${sliderPosition}%)` }}
          >
            {slideTexts.map((text, index) => (
              <div
                className={`slider__layout${
                  activeSlideIndex === index ? "--active" : ""
                }`}
                key={index}
              >
                <p className="slider__description">{text.description}</p>
              </div>
            ))}
          </div>

          <div className="slider__bullets">
            <div className="slider__button__download">
              <a className="button__type__1" href="#portal">
                DOWNLOAD APP
              </a>
            </div>

            <span
              className={`slider__bullet${
                activeSlideIndex === 2 || activeSlideIndex === 6
                  ? "--active"
                  : ""
              }`}
            ></span>
            <span
              className={`slider__bullet${
                activeSlideIndex === 3 ? "--active" : ""
              }`}
            ></span>
            <span
              className={`slider__bullet${
                activeSlideIndex === 4 ? "--active" : ""
              }`}
            ></span>
            <span
              className={`slider__bullet${
                activeSlideIndex === 5 ? "--active" : ""
              }`}
            ></span>
          </div>
        </div>
      </section>
      <div className="control_slider">
        {/*
                <div className="prev_slide"onClick={ slideBack }><img className="carousel__control" src={ arrow } alt="arrow" /></div>
                */}
        <div className="next_slide" onClick={slide}>
          <img className="carousel__control" src={arrow} alt="arrow" />
        </div>
      </div>
    </div>
  ) : (
    <section className="header__slider header__slider--placeholder" />
  );

SliderView.propTypes = {
  slideImages: PropTypes.array,
  slideTexts: PropTypes.array,
  activeSlideIndex: PropTypes.number,
  sliderPosition: PropTypes.number,
  isTransitioned: PropTypes.bool,
  isSlid: PropTypes.bool,
  slide: PropTypes.func,
  isImagesLoaded: PropTypes.bool.isRequired,
};

export default SliderView;
